import { render, staticRenderFns } from "./NewsletterSection.vue?vue&type=template&id=4070ba2d&"
import script from "./NewsletterSection.vue?vue&type=script&lang=js&"
export * from "./NewsletterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\marci\\Desktop\\majorel-china-static\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4070ba2d')) {
      api.createRecord('4070ba2d', component.options)
    } else {
      api.reload('4070ba2d', component.options)
    }
    module.hot.accept("./NewsletterSection.vue?vue&type=template&id=4070ba2d&", function () {
      api.rerender('4070ba2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/NewsletterSection.vue"
export default component.exports